import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import { connect } from "react-redux";
import { useHistory, useLocation, useRouteMatch } from "react-router-dom";
import { showError } from "../../../actions/action_error_alert";
import { showLoading } from "../../../actions/action_loading";
import DonateService from "../../../api/services/GochiKid/DonateService";
import * as constants from "../../../constants";
import { log } from "../../../utils";
import Header from "../layout/Header";
import { clearDonateBankTransferATMData, saveDonateBankTransferATMData } from "../../../actions/GochiKid/action_donate";
import { loadVeritransPopLibrary } from "../../../utils/veritrans";

const Atone = window.Atone;

function DonateConfirm(props) {
  const location = useLocation();
  const history = useHistory();
  const match = useRouteMatch();
  const destination = match.params.destination;
  const previousPath = location.state.previousPath;
  const inputPath = `${constants.GOCHI_KID_PATH}/support/choice/${destination}/input${window.location.search}`;
  const successPath = `${constants.GOCHI_KID_PATH}/support/choice/${destination}/complete`;
  const confirmPath = `${constants.GOCHI_KID_PATH}/support/choice/${destination}/confirm`;

  const [crfsToken, setCrfsToken] = useState('');

  const generateRandomString = (length = 32) => {
    var text = "";
    var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

    for (var i = 0; i < length; i++) { text += possible.charAt(Math.floor(Math.random() * possible.length)); }
    setCrfsToken(text);
    console.log('crfs token', text);
    return text;
  }

  const getDestinationText = () => {
    switch (destination) {
      case 'region':
        return `都道府県（${props.activityInfo?.groupName || ''}）`;
      case 'activity':
        return `自治体/活動（${props.activityInfo?.shopName || props.activityInfo?.groupName || ''}）`;
      default:
        return '全国';
    }
  };

  const getPaymentText = () => {
    switch (props.paymentType) {
      case constants.PAYMENT_TYPE_CREDIT_CARD:
        return 'クレジットカードで決済';
      case constants.PAYMENT_TYPE_PAYPAY:
        return 'PayPayで決済';
      case constants.PAYMENT_TYPE_ONEPAY_ALIPAY:
        return 'Alipayで決済';
      case constants.PAYMENT_TYPE_ATONE:
        return (
          <>
            atone 翌月払い（コンビニ/口座振替）
            <br/>
            <br/>
            <span>※ 申込撤回については</span>
            <a href="https://gochimeshi.com/policy/legal/" target="_blank">特定商取引法に基づく表記</a>
            <span>をご参照ください</span>
          </>
        );
      case constants.PAYMENT_TYPE_VERITRANS_ATM:
        return '銀行振込（ATM）';
      case constants.PAYMENT_TYPE_VERITRANS_INTERNET_BANKING:
        return '銀行振込（ネットバンク）';
      default:
        return '';
    }
  }

  const getCompletePath = (params) => {
    let path = successPath;
    if (params && Object.keys(params).length > 0) {
      let count = 0;
      for (const property in params) {
        path += count === 0 ? '?' : '&';
        path += property + '=' + params[property];
        count++;
      }
    }
    return path;
  }

  const initializeAtone = () => {
    if (Atone) {
      Atone.config({
        pub_key: process.env.REACT_APP_ATONE_PUB_KEY,
        payment: {},
        // This is called upon finishing the authentication or user registration.
        authenticated: function (authenticationToken, userNo) {
          console.log('authentication token ' + authenticationToken);
          console.log('user no ' + userNo);
          localStorage.setItem('atoneToken', authenticationToken);
        },
        // Call upon closing the modal.
        cancelled: function () {
          console.log("cancelled");
        },
        // Call after pressing the button to close the form after the payment has returned as NG.
        failed: function (response) {
          console.log('response failed ' + response);
        },
        // Call after the form has been automatically closed when the payment has returned as OK.
        succeeded: function (response) {
          console.log('response succeeded ' + JSON.stringify(response));
        },
        // Call when an error occurs.
        error: function (name, message, errors) {
          console.log('response error name ' + name);
          console.log('response error message ' + message);
          console.log('response error errors ' + JSON.stringify(errors));
        }
      });
    } else if (!window.Atone && props.paymentType === constants.PAYMENT_TYPE_ATONE) {
			props.showError(true, "※広告ブロック等の理由により、atone決済が表示されません。atone決済をご利用ご希望の方は、ご利用のブラウザを変更してお試しください。", "");
		}
  };

  const startAtoneCheckout = async (atoneJson, merchantPaymentId) => {
    log('Atone JSON: ' + JSON.stringify(atoneJson));
    const options = {
      payment: atoneJson,
      succeeded: function (response) {
        log('response succeeded ' + JSON.stringify(response));
        window.location.replace(getCompletePath({ merchantPaymentId, checkoutId: response.id }));
      }
    };
    if (localStorage.getItem('atoneToken')) {
      options.pre_token = localStorage.getItem('atoneToken');
    }
    if (Atone) {
      Atone.merge(options);
      Atone.sync();
      // Sleep to wait sync done
      await new Promise(resolve => setTimeout(resolve, 1000));
      Atone.start();
    } else if (!window.Atone && props.paymentType === constants.PAYMENT_TYPE_ATONE) {
			props.showError(true, "※広告ブロック等の理由により、atone決済が表示されません。atone決済をご利用ご希望の方は、ご利用のブラウザを変更してお試しください。", "");
		}
  };

  const donateParams = {
    paymentType: props.paymentType,
    donateAmount: props.donateAmount
  };
  if (props.donateMessage && props.donateMessage.length > 0) {
    donateParams.donateMessage = props.donateMessage;
  }
  if (props.shopId) {
    donateParams.shopId = props.shopId;
  } else if (props.groupId) {
    donateParams.groupId = props.groupId;
  }

  if (props.zipcode && props.zipcode.length > 0) {
    donateParams.zipCode = props.zipcode;
  }

  if (props.prefectureName) {
    donateParams.prefecture = props.prefectureName;
  }

  if (props.cityName) {
    donateParams.city = props.cityName;
  }

  if (props.address && props.address.length > 0) {
    donateParams.address = props.address;
  }

  if (props.building && props.building.length > 0) {
    donateParams.building = props.building;
  }

  const submitDonateSubscription = async () => {
    log('submitDonateSubscription');
    props.showLoading(true);
    const params = {
      ...donateParams,
      paymentSource: props.paymentMethod?.token,
      billingGroupId: props.billingGroupId,
      userName: props.userName
    }
    const response = await DonateService.createDonateSubscription(params, crfsToken);
    if (response.status === 200) {
      log('submitDonateSubscription success');
      props.showLoading(false);
      history.replace(getCompletePath({ merchantPaymentId: response.data.merchantPaymentId }));
    } else {
      generateRandomString();
      if (response.status === 402 && response.data) {
        if (response.data.stripe_code === 'expired_card') {
          props.showError(true, '有効期限切れのカードです。', '');
        } else if (response.data.stripe_code === 'amount_too_small') {
          props.showError(true, '最低ご利用金額に達していません。', '');
        } else if (response.data.stripe_code === 'insufficient_funds') {
          props.showError(true, 'カードの残高が不足しています。', '');
        } else if (response.data.stripe_code === 'card_velocity_exceeded') {
          props.showError(true, 'カードの利用限度額を超えています。', '');
        } else if (
          response.data.veritrans_error_code === 'AG33000000000000' ||
          response.data.veritrans_error_code === 'AG44000000000000' ||
          response.data.veritrans_error_code === 'AG45000000000000'
        ) {
          props.showError(true, 'クレジットカードがご利用いただけません。 カードのご利用状況をご確認ください。', '');
        } else if (response.data.veritrans_error_code === 'AG47000000000000') {
          props.showError(true, 'クレジットカードがご利用できません。以下の内容をご確認お願いします。\n・カード番号、有効期限、セキュリティーコードに誤りがある可能性がございますので、ご確認ください。\n・それ以外でご利用できない場合、お使いのクレジットカード会社様にお問合せください。', '');
        } else if (
          response.data.veritrans_error_code === 'AG48000000000000' ||
          response.data.veritrans_error_code === 'AG49000000000000'
        ) {
          props.showError(true, 'ご入力いただいたクレジットカードがご利用できません。以下の内容をご確認お願いします。\n・カード番号、有効期限、セキュリティーコードに誤りがある可能性がございますので、ご確認ください。\n・それ以外でご利用できない場合、お使いのクレジットカード会社様にお問合せください。', '');
        } else if (response.data.veritrans_error_code === 'AG51000000000000') {
          props.showError(true, 'クレジットカードがご利用できません。登録情報のご確認をお願いします。', '');
        } else if (response.data.veritrans_error_code === 'AG64000000000000') {
          props.showError(true, 'クレジットカードがご利用できません。有効期限をご確認ください。', '');
        } else if (
          response.data.veritrans_error_code === 'AG46000000000000' ||
          response.data.veritrans_error_code === 'AGC0000000000000' ||
          response.data.veritrans_error_code === 'AG69000000000000'
        ) {
          props.showError(true, 'クレジットカードがご利用いただけません。お手数ですが、カード会社へお問い合わせください。', '');
        } else if (
          response.data.veritrans_error_code === 'AG65000000000000' ||
          response.data.veritrans_error_code === 'AGB3000000000000'
        ) {
          props.showError(true, 'クレジットカードがご利用いただけません。お手数ですが、他のカードをご利用ください。', '');
        } else if (
          response.data.veritrans_error_code === 'AGB5000000000000' ||
          response.data.veritrans_error_code === 'AGB9000000000000'
        ) {
          props.showError(true, 'クレジットカードがご利用いただけません。 デビットカードのご利用限度額をご確認ください。', '');
        } else if (response.data.veritrans_error_code === 'AGC1000000000000') {
          props.showError(true, 'クレジットカードがご利用いただけません。ご利用残高をご確認ください。', '');
        } else {
          props.showError(true, 'エラーが発生しました。', '');
        }
      } else {
        props.showError(true, 'エラーが発生しました。', '');
      }
      props.showLoading(false);
    }
  };

  const submitDonate = async () => {
    props.clearDonateBankTransferATMData();

    if (props.isSubscription) {
      submitDonateSubscription();
      return;
    }
    props.showLoading(true);
    const params = {
      ...donateParams,
      successUrl: window.location.origin + successPath,
      cancelUrl: window.location.origin + confirmPath,
      domain: window.location.origin,
      userAgent: navigator.userAgent,
      userName: props.userName
    };
    if (!props.userInfo.userId) {
      params.userEmail = props.userEmail;
    }

    if (props.userInfo.userId && (props.paymentType === constants.PAYMENT_TYPE_STRIPE || props.paymentType === constants.PAYMENT_TYPE_VERITRANS)) {
      // Charge Stripe/Veritrans
      params.paymentSource = props.paymentMethod?.token;
      const response = await DonateService.charge(params, crfsToken);
      log(['charge response', response]);
      if (response.status === 200) {
        props.showLoading(false);
        history.replace(getCompletePath({ merchantPaymentId: response.data.merchantPaymentId }));
      } else {
        generateRandomString();
        if (response.status === 402 && response.data) {
          if (response.data.stripe_code === 'expired_card') {
            props.showError(true, '有効期限切れのカードです。', '');
          } else if (response.data.stripe_code === 'amount_too_small') {
            props.showError(true, '最低ご利用金額に達していません。', '');
          } else if (response.data.stripe_code === 'insufficient_funds') {
            props.showError(true, 'カードの残高が不足しています。', '');
          } else if (response.data.stripe_code === 'card_velocity_exceeded') {
            props.showError(true, 'カードの利用限度額を超えています。', '');
          } else if (
            response.data.veritrans_error_code === 'AG33000000000000' ||
            response.data.veritrans_error_code === 'AG44000000000000' ||
            response.data.veritrans_error_code === 'AG45000000000000'
          ) {
            props.showError(true, 'クレジットカードがご利用いただけません。 カードのご利用状況をご確認ください。', '');
          } else if (response.data.veritrans_error_code === 'AG47000000000000') {
            props.showError(true, 'クレジットカードがご利用できません。以下の内容をご確認お願いします。\n・カード番号、有効期限、セキュリティーコードに誤りがある可能性がございますので、ご確認ください。\n・それ以外でご利用できない場合、お使いのクレジットカード会社様にお問合せください。', '');
          } else if (
            response.data.veritrans_error_code === 'AG48000000000000' ||
            response.data.veritrans_error_code === 'AG49000000000000'
          ) {
            props.showError(true, 'ご入力いただいたクレジットカードがご利用できません。以下の内容をご確認お願いします。\n・カード番号、有効期限、セキュリティーコードに誤りがある可能性がございますので、ご確認ください。\n・それ以外でご利用できない場合、お使いのクレジットカード会社様にお問合せください。', '');
          } else if (response.data.veritrans_error_code === 'AG51000000000000') {
            props.showError(true, 'クレジットカードがご利用できません。登録情報のご確認をお願いします。', '');
          } else if (response.data.veritrans_error_code === 'AG64000000000000') {
            props.showError(true, 'クレジットカードがご利用できません。有効期限をご確認ください。', '');
          } else if (
            response.data.veritrans_error_code === 'AG46000000000000' ||
            response.data.veritrans_error_code === 'AGC0000000000000' ||
            response.data.veritrans_error_code === 'AG69000000000000'
          ) {
            props.showError(true, 'クレジットカードがご利用いただけません。お手数ですが、カード会社へお問い合わせください。', '');
          } else if (
            response.data.veritrans_error_code === 'AG65000000000000' ||
            response.data.veritrans_error_code === 'AGB3000000000000'
          ) {
            props.showError(true, 'クレジットカードがご利用いただけません。お手数ですが、他のカードをご利用ください。', '');
          } else if (
            response.data.veritrans_error_code === 'AGB5000000000000' ||
            response.data.veritrans_error_code === 'AGB9000000000000'
          ) {
            props.showError(true, 'クレジットカードがご利用いただけません。 デビットカードのご利用限度額をご確認ください。', '');
          } else if (response.data.veritrans_error_code === 'AGC1000000000000') {
            props.showError(true, 'クレジットカードがご利用いただけません。ご利用残高をご確認ください。', '');
          } else {
            props.showError(true, 'エラーが発生しました。', '');
          }
        } else {
          props.showError(true, "エラーが発生しました。", "");
        }
        props.showLoading(false);
      }
    } else {
      // Checkout
      let windowReference = null;
      if (props.paymentType === constants.PAYMENT_TYPE_ONEPAY_ALIPAY) {
        windowReference = window.open();
      }
      if (props.paymentType === constants.PAYMENT_TYPE_VERITRANS) {
        // Dynamic load Veritrans Pop library
        await loadVeritransPopLibrary();
        // Show loading of Veritrans popup
        props.showLoading(false);
        window.pop.show();
      }
      const response = await DonateService.createCheckoutSession(params);
      if (response.status === 200) {
        if (props.paymentType === constants.PAYMENT_TYPE_STRIPE) {
          const stripeCheckoutPath = '/stripeCheckout?sessionId=' + response.data.stripeSessionId;
          props.showLoading(false);
          history.replace(stripeCheckoutPath);
        } else if (props.paymentType === constants.PAYMENT_TYPE_VERITRANS) {
          const options = {
            autoReturn: true,
            autoReturnDelay: 5,
            onSuccess: function () {
              log('success pop');
              history.replace(getCompletePath({ merchantPaymentId: response.data.merchantPaymentId }));
            },
            onFailure: function () {
              log('failure pop');
            },
            onIncomplete: function () {
              log('incomplete pop');
            }
          };
          window.pop.pay(response.data.checkoutToken, options);
        } else if (props.paymentType === constants.PAYMENT_TYPE_ONEPAY_ALIPAY) {
          if (isMobile) {
            windowReference.location = response.data.redirectUrl;
            setTimeout(() => {
              try {
                const refHostname = windowReference.location.hostname;
                if (refHostname !== 'mobile.alipay.com')
                  windowReference.close();
              } catch (e) {}
              props.showLoading(false);
              window.location.replace(getCompletePath({ merchantPaymentId: response.data.merchantPaymentId, retry: 5 }));
            }, 5000);
          } else {
            windowReference.location = `${window.location.origin}/alipay-qr-code?value=${encodeURIComponent(response.data.redirectUrl)}&ts=${Date.now()}`;
            props.showLoading(false);
            window.location.replace(getCompletePath({ merchantPaymentId: response.data.merchantPaymentId, retry: 5 }));
          }
        } else if (props.paymentType === constants.PAYMENT_TYPE_ATONE) {
          await startAtoneCheckout(response.data.atoneJson, response.data.merchantPaymentId);
          props.showLoading(false);
        } else if (props.paymentType === constants.PAYMENT_TYPE_VERITRANS_ATM) {
          const bankTransferATMData = {
            merchantPaymentId: response.data.merchantPaymentId,
            shunoKikanNo: response.data.shunoKikanNo,
            customerNo: response.data.customerNo,
            confirmNo: response.data.confirmNo
          };
          props.saveDonateBankTransferATMData(bankTransferATMData);
          props.showLoading(false);
          history.push(
            `${constants.GOCHI_KID_PATH}/support/choice/${destination}/transfer-atm${window.location.search}`,
            { previousPath: window.location.pathname + window.location.search, previousPathConfirm: previousPath }
          );
        } else if (props.paymentType === constants.PAYMENT_TYPE_VERITRANS_INTERNET_BANKING) {
          window.location.href = response.data.veritransUrl;
        } else {
          // PayPay
          window.location.replace(response.data.redirectUrl);
        }
      } else {
        if (windowReference) {
          windowReference.close();
        }
        if (props.paymentType === constants.PAYMENT_TYPE_VERITRANS) {
          window.pop.hide();
        }
        // TODO: error message
        props.showError(true, "エラーが発生しました。", "");
        props.showLoading(false);
      }
    }
  };

  useEffect(() => {
    log('DonateConfirm componentDidMount');

    if (!props.donateAmount) {
      history.replace(inputPath);
      return;
    }

    initializeAtone();

    generateRandomString();

    // getActivityInfo().then(() => {
      // Scroll to top after first load
    window.scrollTo(0, 0);
    // });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <Header />

      <main className="page-wrapper">
        <div className="page-content donate-payment">

          <div className="font-family-rounded title-donate text-center color-2F1A1C mb-3">支援内容の確認</div>
          <ul className="payment-progress-bar align-center">
            <li>入力</li>
            <li className="active">確認</li>
            <li>完了</li>
          </ul>

          <table className="donate-table">
            <thead>
              <tr>
                <th>項目</th>
                <th>入力内容</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>支援先 <span className="color-ED808C">*</span></td>
                <td>{getDestinationText()}</td>
              </tr>
              <tr>
                <td>金額 <span className="color-ED808C">*</span></td>
                <td>{(props.donateAmount || 0).toLocaleString()}円</td>
              </tr>
              <tr>
                <td>回数 <span className="color-ED808C">*</span></td>
                <td>{props.isSubscription ? "継続（1ヶ月1回）" : "一度だけ"}</td>
              </tr>
              <tr>
                <td>お支払い方法 <span className="color-ED808C">*</span></td>
                <td>{getPaymentText()}</td>
              </tr>
              {!props.userInfo.userId && (
                <tr>
                  <td>メールアドレス <span className="color-ED808C">*</span></td>
                  <td>{props.userEmail || ''}</td>
                </tr>
              )}
              <tr>
                <td>氏名 <span className="color-ED808C">*</span></td>
                <td className="space-pre-wrap">{props.userName || ''}</td>
              </tr>
              <tr>
                <td>郵便番号</td>
                <td>{props.zipcode || ''}</td>
              </tr>
              <tr>
                <td>都道府県</td>
                <td>{props.prefectureName || ''}</td>
              </tr>
              <tr>
                <td>市区町村</td>
                <td>{props.cityName || ''}</td>
              </tr>
              <tr>
                <td>町域・番地</td>
                <td className="space-pre-wrap">{props.address || ''}</td>
              </tr>
              <tr>
                <td>建物名</td>
                <td className="space-pre-wrap">{props.building || ''}</td>
              </tr>
              <tr>
                <td>こども達へのメッセージ</td>
                <td className="space-pre-wrap">{props.donateMessage || ''}</td>
              </tr>
            </tbody>
          </table>

          <div className="mt-4">
            <button className="btn-primary btn-size-md w-100" onClick={submitDonate}>
              支援を完了する
              <i className="icon-next-destination" />
            </button>
          </div>
          <div className="mt-4 text-center">
            <button className="btn-link fw-400 border-0 p-0" onClick={() => history.replace(previousPath)}>
              前の画面に戻る
            </button>
          </div>

        </div>
      </main>
    </>
  );
}

const mapStateToProps = state => ({
    userInfo: state.userInfo,
    paymentMethod: state.paymentMethod,
    paymentType: state.gochiKid.donate.paymentType,
    isSubscription: state.gochiKid.donate.isSubscription,
    billingGroupId: state.gochiKid.donate.billingGroupId,
    activityInfo: state.gochiKid.donate.activityInfo,
    shopId: state.gochiKid.donate.shopId,
    groupId: state.gochiKid.donate.groupId,
    donateAmount: state.gochiKid.donate.donateAmount,
    userEmail: state.gochiKid.donate.userEmail,
    userName: state.gochiKid.donate.userName,
    zipcode: state.gochiKid.donate.zipcode,
    prefectureName: state.gochiKid.donate.prefectureName,
    cityName: state.gochiKid.donate.cityName,
    address: state.gochiKid.donate.address,
    building: state.gochiKid.donate.building,
    donateMessage: state.gochiKid.donate.donateMessage
});

const mapDispatchToProps = dispatch => ({
  showLoading: (showing) => dispatch(showLoading(showing)),
  showError: (showing, title, content, buttonName, gotoUrl) => dispatch(showError(showing, title, content, buttonName, gotoUrl)),
  saveDonateBankTransferATMData: (bankTransferATMData) => dispatch(saveDonateBankTransferATMData(bankTransferATMData)),
  clearDonateBankTransferATMData: () => dispatch(clearDonateBankTransferATMData())
});

export default connect(mapStateToProps, mapDispatchToProps)(DonateConfirm);
